@if (isLoading) {
  <div class="lb-loading">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <div class="lb-container">
    @for (row of displayData; track row.rank; let i = $index) {
      <div class="lb-row"
        [ngClass]="{'green_border' : row.user_id != null, 'leaderboard_odd': i % 2 === 0}"
        >
        <div class="lb-rank">
          <div class="lb-rank-trophy">
            @switch (row.rank) {
              @case (1) {
                <fa-icon icon="trophy" class="first_place" ></fa-icon>
              }
              @case (2) {
                <fa-icon icon="trophy" class="second_place"></fa-icon>
              }
              @case (3) {
                <fa-icon icon="trophy" class="third_place"></fa-icon>
              }
              @default {
                &nbsp;
              }
            }
          </div>
          <div class="lb-rank-number">
            {{row.rank}}
          </div>
        </div>
        <div class="lb-center">
          <div class="lb-center-top">
            {{row.first_name}} {{row.last_name}}
          </div>
          <div class="lb-center-bottom">
            {{row.client_name}}
          </div>
        </div>
        <div class="lb-score">
          {{row.view_count ?? row.video_count ?? row.score | number}}
        </div>
      </div>
    }
    <div class="lb-row">
      <div class="lb-center">
        @if (showHowToLink) {
          <div class="green_border">
            <a mat-button target="_blank" (click)="didClickHowTo()" href="https://support.salesmail.com/portal/en/kb/articles/salesmail-leaderboard">
              Click here to see how you can get on the leaderboard!
            </a>
          </div>
        }
      </div>
    </div>
  </div>
}
